import { required, minLength,maxLength } from 'vuelidate/lib/validators';
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const validGST = value =>
    !!value &&
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value);
    const numeric = value => /^\d+(\.\d+)?$/.test(value);
    const nonZeroAmount = value => parseFloat(value) > 0;
export default {
  gstNumber: {
    required,
    validGST,
  },
  amount: {
    required,
    numeric,
    nonZeroAmount,
    minLength: minLength(1),
    maxLength: maxLength(10), // optional limit
  },
};
